import React, { useState, useEffect } from 'react';
import toggleStyles from './Toggle.module.css';
import classNames from "classnames";

export const Toggle = (props) => {
  const { initialState, trueLabel, falseLabel, onChange, disabled, ...buttonProps } = props;
  const [toggleState, setToggleState] = useState(initialState);

  useEffect(() => {
    onChange(toggleState);
  }, [toggleState]);

  const toggle = () => {
    setToggleState((prev) => !prev);
  };

  return (
    <button
      {...buttonProps}
      type="button"
      aria-pressed={toggleState}
      disabled={disabled}
      className = { classNames(toggleStyles.element, toggleState ? toggleStyles.active : '') }
      onClick={toggle}>
      <span className={toggleStyles.toggler}></span>
    </button>
  );
}
